module.exports = __webpack_public_path__ + "3998f3ba340eed094f62987f46d182c1.png";